import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RequestStatus } from '../../../config/store';
import { RootState } from '../../../store/rootStore';
import { getLibraries } from '../store/libraries.store';
import LibrariesTable from '../components/LibrariesTable';
import EditLibraryModal from '../modals/EditLibraryModal';
import DeleteLibraryModal from '../modals/DeleteLibraryModal';
import useCurrentUser from '../../../hooks/useCurrentUser';
import { useModal } from '@moovly/ui';

const LibrariesContainer: React.FC = () => {
  const { isOrganizationAdmin, parentOrganizationId, groupsWithAdminRight, isDone } = useCurrentUser();
  const { libraries } = useSelector((state: RootState) => state.libraries);
  const dispatch = useDispatch<any>();
  const {
    isOpen: editLibraryModalOpen,
    modalProps: editLibrary,
    openModal: openEditLibraryModal,
    ...otherEditLibraryModalProps
  } = useModal();

  const {
    isOpen: deleteLibraryModalOpen,
    modalProps: deleteLibrary,
    openModal: openDeleteLibraryModal,
    ...otherDeleteLibraryModalProps
  } = useModal();

  React.useEffect(() => {
    if (libraries.request.get.status === RequestStatus.Unsent && isDone)
      dispatch(
        getLibraries({
          organizationId: (isOrganizationAdmin && parentOrganizationId) || undefined,
          groupIds: groupsWithAdminRight.map((gr) => gr.id),
        })
      );
  }, [libraries.request.get.status, isOrganizationAdmin, parentOrganizationId, groupsWithAdminRight, isDone, dispatch]);

  return (
    <>
      <LibrariesTable
        libraries={libraries.data}
        isLoading={libraries.request.get.status === RequestStatus.Pending}
        onEdit={openEditLibraryModal}
        onDelete={openDeleteLibraryModal}
      />
      {editLibraryModalOpen && <EditLibraryModal library={editLibrary} {...otherEditLibraryModalProps} />}
      {deleteLibraryModalOpen && <DeleteLibraryModal library={deleteLibrary} {...otherDeleteLibraryModalProps} />}
    </>
  );
};

export default LibrariesContainer;
